import { post } from "../../../services/request";

const documentTypeService = {
    fetchDocumentTypes: (data) =>
        post('Document/GetDocumentTypeList', data),

    saveDocumentType: (data) =>
        post('Document/SaveDocumentType', data),

    deleteDocumentType: (data) =>
        post('Document/DeleteDocumentType', data),

    getDocumentTypeById: (data) =>
        post('Document/GetDocumentTypeById', data),
};

export default documentTypeService;
